import { assignInlineVars } from '@vanilla-extract/dynamic';
import { cx } from 'emotion';
import {
  memo,
  forwardRef,
  isValidElement,
  HTMLAttributes,
  ReactNode,
  ComponentType,
  ReactElement,
} from 'react';

import {
  noPadding,
  denseStyle,
  sparseStyle,
  leftBoundaryStyle,
  rightBoundaryStyle,
  buttonContentMargin,
  transparentStyle,
  buttonContent,
  buttonVariants,
} from './Button.css';

/* eslint-disable react/no-unused-prop-types */
type ButtonType = {
  children?: ReactNode;
  icon?: ComponentType | ReactElement;
  dense?: boolean;
  sparse?: boolean;
  disabled?: boolean;
  transparent?: boolean;
  leftBoundary?: boolean;
  rightBoundary?: boolean;
  variant?: keyof typeof buttonVariants;
};
/* eslint-enable react/no-unused-prop-types */

export const Button = memo(forwardRef<
  HTMLButtonElement,
  HTMLAttributes<HTMLButtonElement> & ButtonType
>(
  (
    {
      children,
      className,
      icon: Icon,
      dense,
      sparse,
      disabled,
      leftBoundary,
      rightBoundary,
      transparent,
      variant = 'gradient',
      ...props
    },
    ref
  ) => (
    <button
      {...props}
      type="button"
      ref={ref}
      className={cx(
        buttonVariants[variant],
        {
          [noPadding]: !children,
          [denseStyle]: dense,
          [sparseStyle]: sparse,
          [transparentStyle]: transparent,
          [leftBoundaryStyle]: leftBoundary,
          [rightBoundaryStyle]: rightBoundary,
        },
        className
      )}
      disabled={disabled}
      data-hastext={!!children}
      data-hasicon={!!Icon}
    >
      {/* @ts-expect-error */}
      {!!Icon && (isValidElement(Icon) ? Icon : <Icon />)}
      {!!children && (
        <span
          style={({
            ...assignInlineVars({
              [buttonContentMargin]: Icon ? '4px' : '0px',
            }),
          })}
          className={buttonContent}
        >
          {children}
        </span>
      )}
    </button>
  )
));
